// src/pages/About.tsx
import React from 'react';

import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";

import ServiceSection from '../components/ServiceSection';
import GetInTouch from '../components/GetInTouch';


const OurServices: React.FC = () => {


const seo = seoConfig.services; // ✅ Load meta for this page

  return (


<>


      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        image={seo.image}
      />



  {/* rts bread crumba rea start */}
  <div className="rts-breadcrumb-area-services bg_image">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="baread-crumb-main-wrapper pt--100">
            <div className="inner">
              <h1 className="title rts_hero__title">Services</h1>
              <span className="bg-text d-none d-md-inline">Manikarn Digital</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* rts bread crumba rea end */}




{/* ==== Service Section start ==== */}
  <ServiceSection />
{/* ==== / Service Section end ==== */}  








{/* ==== GetInTouch Section start ==== */}
<GetInTouch />
{/* ==== / GetInTouch Section end ==== */}  




</>


  );
};

export default OurServices;
